import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { SliceActions } from '../types';

export type TDeletePlaceType = 'chat' | 'gallery';

export type TDeleteMessageState = {
  chatId: string | null;
  messageId: string | null;
  deletedMessageId: string | null;
  isModalOpen: boolean;
  placeType: TDeletePlaceType | null;
};

type TOpenModalPayload = {
  chatId: string;
  messageId: string;
  placeType: TDeletePlaceType;
};

const initialState: TDeleteMessageState = {
  chatId: null,
  messageId: null,
  deletedMessageId: null,
  isModalOpen: false,
  placeType: null,
};

const deleteMessageSlice = createSlice({
  name: 'deleteMessage',
  reducers: {
    openModal: (state, action: PayloadAction<TOpenModalPayload>) => {
      state.chatId = action.payload.chatId;
      state.messageId = action.payload.messageId;
      state.placeType = action.payload.placeType;
      state.isModalOpen = true;
    },
    closeModal: state => {
      state.chatId = null;
      state.messageId = null;
      state.placeType = null;
      state.isModalOpen = false;
    },
    saveDeletedMessageId: state => {
      state.deletedMessageId = state.messageId;
    },
    resetSavedDeletedMessageId: state => {
      state.deletedMessageId = null;
    },
  },
  initialState,
});

export const deleteMessageReducer = deleteMessageSlice.reducer;
export const {
  openModal: openDeleteMessageModal,
  closeModal: closeDeleteMessageModal,
  saveDeletedMessageId,
  resetSavedDeletedMessageId,
} = deleteMessageSlice.actions;

export type TDeleteMessageActions = SliceActions<typeof deleteMessageSlice.actions>;
